/** Drop duplicate `value` keys (e.g. same vendor_key twice in search results). */
export const dedupeVendorSelectOptions = (options) => {
  const seen = new Set();
  return options.filter((opt) => {
    const key = String(opt?.value ?? "");
    if (!key || seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/**
 * PAN search can return a PAN whose name matches but not every JODL GST under it.
 * Only keep GST rows that match the typed query on GST fields (not pan_name alone).
 */
export const jodlGstMatchesSellerSearchQuery = (gst, query) => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const display = String(gst.display_name ?? "").toLowerCase();
  const gstNo = String(gst.gst_number ?? "").toLowerCase();
  const vKey = String(gst.vendor_key ?? "").toLowerCase();
  return display.includes(q) || gstNo.includes(q) || vKey.includes(q);
};

/** Sentinel value for "Select all" in location multi-select (never sent to API). */
export const SELECT_ALL_LOCATIONS_VALUE = "__SELECT_ALL_LOCATIONS__";

export const prependSelectAllLocationOption = (locationOptions) => [
  { label: "Select all", value: SELECT_ALL_LOCATIONS_VALUE, extraInfo: "" },
  ...locationOptions,
];

export const realKeysFromLocationOptions = (options) =>
  options
    .filter((o) => o.value !== SELECT_ALL_LOCATIONS_VALUE)
    .map((o) => String(o.value));

export const stripSelectAllToken = (keys) =>
  keys.filter((k) => k !== SELECT_ALL_LOCATIONS_VALUE);

export const normalizeVendorLocationSelection = (newValues, allRealKeys, prevSelected) => {
  if (!allRealKeys.length) return [];
  const hasToken = newValues.includes(SELECT_ALL_LOCATIONS_VALUE);
  const realOnly = stripSelectAllToken(newValues);
  const prevHadAll =
    allRealKeys.length > 0 && allRealKeys.every((k) => prevSelected.includes(k));

  if (hasToken) {
    if (prevHadAll && realOnly.length < allRealKeys.length) {
      return realOnly;
    }
    return [...allRealKeys];
  }
  return realOnly;
};

/** Value passed to Autocomplete so "Select all" appears checked when every location is selected. */
export const vendorLocationAutocompleteValue = (stored, allRealKeys) => {
  const arr = Array.isArray(stored) ? [...stored] : stored ? [String(stored)] : [];
  const keysOnly = stripSelectAllToken(arr);
  const allOn =
    allRealKeys.length > 0 && allRealKeys.every((k) => keysOnly.includes(k));
  if (allOn) {
    return [...keysOnly, SELECT_ALL_LOCATIONS_VALUE];
  }
  return keysOnly;
};
